module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-search"
  }, [_c('el-row', [_c('el-form', {
    attrs: {
      "label-width": "68px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6,
      "offset": 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": "64"
    },
    model: {
      value: (_vm.licenseSearchObj.packageName),
      callback: function($$v) {
        _vm.$set(_vm.licenseSearchObj, "packageName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "licenseSearchObj.packageName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.emptyLicenseSearch
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.searchLicenseList
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list"
  }, [(_vm.isReady == true && _vm.licenseListData.length == 0 && !_vm.noDataObj.packageName) ? _c('div', {
    staticClass: "package-no-data"
  }, [_vm._v("一大波优惠在路上，敬请期待")]) : _vm._e(), _vm._v(" "), (_vm.isReady == true && _vm.licenseListData.length == 0 && _vm.noDataObj.packageName) ? _c('div', {
    staticClass: "package-no-data"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-right": "-30px"
    }
  }, _vm._l((_vm.licenseListData), function(item) {
    return _c('el-col', {
      key: item.packageGuid,
      attrs: {
        "span": 8
      }
    }, [_c('el-card', {
      staticClass: "sense-card-new"
    }, [_c('div', {
      staticClass: "card-new-header clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h3', {
      staticClass: "fl sense-ellipsis",
      attrs: {
        "title": item.packageName
      }
    }, [_vm._v(_vm._s(item.packageName))]), _vm._v(" "), _c('el-popover', {
      attrs: {
        "placement": "right-start",
        "width": "270",
        "trigger": "click"
      }
    }, [_c('el-form', {
      attrs: {
        "size": "small",
        "label-width": "100px"
      }
    }, [(item.packageType == 1) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "许可形式"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(item.detail.licenseForm)))])]), _vm._v(" "), (item.detail.licenseForm == 2) ? _c('el-form-item', {
      attrs: {
        "label": "系统平台"
      }
    }, [(item.detail.platform == 7) ? _c('div', {
      staticClass: "sense-text",
      staticStyle: {
        "position": "relative",
        "top": "-2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t传统 (\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('em', {
      staticClass: "ssicon ss-windows",
      attrs: {
        "title": "Windows"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "ssicon ss-linux",
      attrs: {
        "title": "Linux"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "ssicon ss-mac",
      attrs: {
        "title": "Mac"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('div', {
      staticClass: "sense-text",
      staticStyle: {
        "position": "relative",
        "top": "-2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t智能(\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('em', {
      staticClass: "ssicon ss-android",
      attrs: {
        "title": "Android"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "arm-linux-icon",
      attrs: {
        "title": "ARM Linux"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "许可周期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(item.detail.licensePeriod)))])]), _vm._v(" "), (item.detail.licenseForm == 1) ? _c('el-form-item', {
      attrs: {
        "label": "使用计数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.useCount ? item.detail.useCount : '--'))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && item.detail.platform == 7) ? _c('el-form-item', {
      attrs: {
        "label": "许可类型"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("concurrentFilter")(item.detail.hasConcurrent, item.detail.concurrentType, item.detail.concurrent)))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && ((item.detail.platform == 7 && item.detail.hasConcurrent == false) || (item.detail.platform & 24) > 0)) ? _c('el-form-item', {
      attrs: {
        "label": "同时绑定数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.bindLimit))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && item.detail.hasConcurrent == false && item.detail.platform == 7) ? _c('el-form-item', {
      attrs: {
        "label": "累积绑定数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.maxBound))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "label": "许可数量"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.licenseCount)))])])], 1) : _vm._e(), _vm._v(" "), (item.packageType == 2) ? _c('el-form-item', {
      attrs: {
        "label": "更新次数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.updateCount)))])]) : _vm._e(), _vm._v(" "), (item.packageType == 3) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "计费方式"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(item.detail.chargeMode)))])]), _vm._v(" "), (item.detail.chargeMode == 1) ? _c('el-form-item', {
      attrs: {
        "label": "升级次数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.upgradeCount))])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('el-form-item', {
      attrs: {
        "label": "硬件锁数量"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.dongleCount))])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('el-form-item', {
      attrs: {
        "label": "硬件锁周期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(item.detail.donglePeriod)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "套餐有效期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(item.packagePeriod)))])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "套餐失效日期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("expireTimeFilter")(item.expireTime)))])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "原价"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_c('del', [_vm._v("￥" + _vm._s(item.originPrice))])])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "套餐价"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v("￥" + _vm._s(item.packagePrice))])])], 1), _vm._v(" "), _c('span', {
      staticClass: "fr ssicon ss-info",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    })], 1)], 1), _vm._v(" "), (item.packageType == 1) ? _c('ul', {
      staticClass: "card-new-con"
    }, [(item.detail.licenseForm == 2) ? _c('li', {
      staticClass: "plat"
    }, [(item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-windows",
      attrs: {
        "title": "Windows"
      }
    }) : _vm._e(), _vm._v(" "), (item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-linux",
      attrs: {
        "title": "Linux"
      }
    }) : _vm._e(), _vm._v(" "), (item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-mac",
      attrs: {
        "title": "Mac"
      }
    }) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('em', {
      staticClass: "ssicon ss-android",
      attrs: {
        "title": "Android"
      }
    }) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('em', {
      staticClass: "arm-linux-big-icon",
      attrs: {
        "title": "ARM Linux"
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("许可形式")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(item.detail.licenseForm)))])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("许可周期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(item.detail.licensePeriod)))])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("许可数量")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.licenseCount)))])])]) : _vm._e(), _vm._v(" "), (item.packageType == 2) ? _c('ul', {
      staticClass: "card-new-con"
    }, [_c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("更新次数")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.updateCount)))])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("套餐有效期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(item.packagePeriod)))])])]) : _vm._e(), _vm._v(" "), (item.packageType == 3) ? _c('ul', {
      staticClass: "card-new-con"
    }, [_c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("计费方式")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(item.detail.chargeMode)))])]), _vm._v(" "), (item.detail.chargeMode == 1) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("升级次数")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.detail.upgradeCount))])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("硬件锁数量")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.detail.dongleCount))])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2 && item.detail.donglePeriod) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("硬件锁周期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(item.detail.donglePeriod)))])]) : _vm._e(), _vm._v(" "), (!item.detail.donglePeriod) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("套餐有效期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(item.packagePeriod)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-new-footer clearfix"
    }, [_c('b', {
      staticClass: "fl"
    }, [_vm._v("￥" + _vm._s(item.packagePrice))]), _vm._v(" "), _c('del', {
      staticClass: "fl"
    }, [_vm._v("￥" + _vm._s(item.originPrice))]), _vm._v(" "), _c('el-button', {
      staticClass: "fr",
      attrs: {
        "size": "small",
        "type": "primary",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.licenseBuy(item)
        }
      }
    }, [_vm._v("立即购买")])], 1)])], 1)
  }), 1)], 1), _vm._v(" "), (_vm.licenseObj.total > 0) ? _c('div', {
    staticClass: "sense-table-pager"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.licenseObj.currentPage,
      "page-sizes": [9, 18, 27],
      "page-size": _vm.licenseObj.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.licenseObj.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  }, [_c('el-dialog', {
    staticClass: "sense-dialog",
    attrs: {
      "title": "购买确认",
      "visible": _vm.licenseBuyFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.licenseBuyFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.licenseBuyForm,
      "size": "small",
      "label-width": "120px"
    }
  }, [(_vm.licenseBuyForm.packageType == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.packageName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "许可形式"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(_vm.licenseBuyForm.detail.licenseForm)))])]), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 2) ? _c('el-form-item', {
    attrs: {
      "label": "系统平台"
    }
  }, [(_vm.licenseBuyForm.detail.platform == 7) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t传统 (\n\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-windows",
    attrs: {
      "title": "Windows"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-linux",
    attrs: {
      "title": "Linux"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-mac",
    attrs: {
      "title": "Mac"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((_vm.licenseBuyForm.detail.platform & 24) > 0) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t智能(\n\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-android",
    attrs: {
      "title": "Android"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "arm-linux-icon",
    attrs: {
      "title": "ARM Linux"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "许可周期"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(_vm.licenseBuyForm.detail.licensePeriod)))])]), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 1) ? _c('el-form-item', {
    attrs: {
      "label": "使用计数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.useCount ? _vm.licenseBuyForm.detail.useCount : '--'))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 2 && _vm.licenseBuyForm.detail.platform == 7) ? _c('el-form-item', {
    attrs: {
      "label": "许可类型"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("concurrentFilter")(_vm.licenseBuyForm.detail.hasConcurrent, _vm.licenseBuyForm.detail.concurrentType, _vm.licenseBuyForm.detail.concurrent)))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 2 && ((_vm.licenseBuyForm.detail.platform == 7 && _vm.licenseBuyForm.detail.hasConcurrent == false) || (_vm.licenseBuyForm.detail.platform & 24) > 0)) ? _c('el-form-item', {
    attrs: {
      "label": "同时绑定设备数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.bindLimit))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 2 && _vm.licenseBuyForm.detail.hasConcurrent == false && _vm.licenseBuyForm.detail.platform == 7) ? _c('el-form-item', {
    attrs: {
      "label": "累积绑定设备数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.maxBound))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "许可数量"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.licenseBuyForm.detail.licenseCount)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.packageType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "更新次数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.licenseBuyForm.detail.updateCount)))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.packageType == 3) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "计费方式"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(_vm.licenseBuyForm.detail.chargeMode)))])]), _vm._v(" "), (_vm.licenseBuyForm.detail.chargeMode == 1) ? _c('el-form-item', {
    attrs: {
      "label": "升级次数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.upgradeCount))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.chargeMode == 2) ? _c('el-form-item', {
    attrs: {
      "label": "硬件锁数量"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.dongleCount))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.chargeMode == 2) ? _c('el-form-item', {
    attrs: {
      "label": "硬件锁周期"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(_vm.licenseBuyForm.detail.donglePeriod)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐有效期"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(_vm.licenseBuyForm.packagePeriod)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐失效日期"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("expireTimeFilter")(_vm.licenseBuyForm.expireTime)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_c('del', [_vm._v("￥" + _vm._s(_vm.licenseBuyForm.originPrice))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐价"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v("￥" + _vm._s(_vm.licenseBuyForm.packagePrice))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "sense-tip-blue"
  }, [_vm._v("点击“确定”按钮将从您的账户中扣除相应费用")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.licenseBuyFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.licenseBuyFormSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20678733"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Package.vue
// module id = 577
// module chunks = 1